export enum RelatedObjectType {
  ACTIVITY = "ACTIVITY",
  GOAL = "GOAL",
  CONTACT = "CONTACT",
  SIGNAL = "SIGNAL",
  FEEDBACK = "FEEDBACK",
  ACTION_ITEM = "ACTION_ITEM",
}
